import React from 'react';
import { CheckCircle2 } from 'lucide-react';
interface FormCardProps {
  title: string;
  description?: string;
  isValid?: boolean;
  children: React.ReactNode;
  className?: string;
}
export function FormCard({
  title,
  description,
  isValid = false,
  children,
  className = ''
}: FormCardProps) {
  return <div className={`
      group bg-white rounded-xl border border-slate-200/60 shadow-sm hover:shadow-md 
      transition-all duration-300 ease-out overflow-hidden
      ${isValid ? 'ring-1 ring-green-500/20 border-green-500/30' : ''}
      ${className}
    `} data-id="element-36">
      <div className="p-6 sm:p-8" data-id="element-37">
        <div className="flex items-start justify-between mb-6" data-id="element-38">
          <div className="space-y-1" data-id="element-39">
            <h2 className="text-lg font-semibold text-slate-900 tracking-tight" data-id="element-40">
              {title}
            </h2>
            {description}
          </div>

          <div className={`
            flex items-center justify-center w-8 h-8 rounded-full 
            transition-all duration-500 ease-spring
            ${isValid ? 'bg-green-100 text-green-600 scale-100 rotate-0' : 'bg-slate-50 text-slate-300 scale-90 opacity-0'}
          `} data-id="element-41">
            <CheckCircle2 size={18} strokeWidth={2.5} data-id="element-42" />
          </div>
        </div>

        <div className="space-y-5" data-id="element-43">{children}</div>
      </div>

      {/* Decorative bottom bar for valid state */}
      <div className={`
        h-1 w-full bg-gradient-to-r from-green-400 to-emerald-500
        transition-transform duration-500 ease-out origin-left
        ${isValid ? 'scale-x-100' : 'scale-x-0'}
      `} data-id="element-44" />
    </div>;
}